import {BoxType} from 'client/common/types';

const CREATIVE_BOX_TYPES: readonly BoxType[] = ['creative', 'bordomatik'] as const;

export function getIsCreativeBox(boxType?: BoxType): boolean {
    return Boolean(boxType && CREATIVE_BOX_TYPES.includes(boxType));
}
